<template>
    <img src="/images/promo/connect-features/tornado.png"
     alt="Tornado" />
</template>

<script>
export default {};
</script>
